export default __webpack_public_path__ + "static/media/point-white.66c33325.svg";